<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content" *ngIf="Type=='FromMain'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-body padding-top-0px margin-left-0px padding-right-0px padding-left-0px padding-bottom-0px">

        <div class="modal-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Categories">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Individual">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <div class="card" *ngIf="Categories">
            <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

              Add New Bill

              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card-body margin-left-0px">
              <div class="margin-left-zero p-0 margin-top-20px">
                <div class="card height-100pe">


                  <div class="" *ngIf="Categories">
                    <!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="offset-md-1 col">
                          <label class="radio-inline">

                            Individual<a class="nav-link-hand margin-left-5px" (click)="individual1()"> <input type="radio"> </a>
                          </label>
                        </div>
                        <div class="col">
                          <label class="radio-inline">

                            Donor<a class="nav-link-hand margin-left-5px" (click)="donor()"> <input type="radio"> </a>
                          </label>
                        </div>
                        <div class="col">
                          <label class="radio-inline">

                            Couple<a class="nav-link-hand margin-left-5px" (click)="couple()"> <input type="radio"> </a>
                          </label>
                        </div>


                      </div>

                    </div>-->
                    <div class="row height-100pe padding-top-10px padding-bottom-20px">
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="PatientsOpadv('opbill')">
                        <div class="padding-all-15pe height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="PatientsOpadv('opbill')">
                            <h4 class="text-align-center font-size-18px">OP BILL</h4>
                            <!--<div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>-->


                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="individual1()">
                        <div class="padding-all-15pe height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="individual1()">
                            <h4 class="text-align-center font-size-18px">IPBILL</h4>
                            <!--<div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>-->


                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="PatientsOpadv('Opadv')">
                        <div class="padding-all-15pe height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="PatientsOpadv('Opadv')">
                            <h4 class="text-align-center font-size-18px">OP ADV</h4>
                            <!--<div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>-->


                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="PatientsOpadv('Ipadv')">
                        <div class="padding-all-15pe height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="PatientsOpadv('Ipadv')">
                            <h4 class="text-align-center font-size-18px">IP ADV</h4>
                            <!--<div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>-->


                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="PatientsOpadv('RxBill')">
                        <div class="padding-all-15pe height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="PatientsOpadv('RxBill')">
                            <h4 class="text-align-center font-size-18px">RX BILL</h4>
                            <!--<div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>-->


                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="AddRefund()">
                        <div class="padding-all-15pe height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="AddRefund()">
                            <h4 class="text-align-center font-size-18px">REFUND</h4>
                            <!--<div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>-->


                          </div>
                        </div>
                      </div>
                      <!--<div class="col-md-4">
                        <div class="card height-100pe">
                          <div class="card-header">
                            <label>Individual</label>
                          </div>
                          <div class="card-body">
                            <i class="fas fa-user font-size-20px"></i>
                          </div>
                        </div>
                      </div>-->
                      <!--<div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="donor()">
                        <div class="padding-all-10px height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="donor()">
                            <h4 class=" text-align-center font-size-18px">Donor</h4>
                            <div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="couple()">
                        <div class="padding-all-10px height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="couple()">
                            <h4 class="text-align-center font-size-18px">Couple</h4>
                            <div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>
                          </div>
                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
            </div>
          </div>

          <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12   document" *ngIf="opadvance">


            <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

              <div class="row" *ngIf="PatientDetails">
                <div class="col-md-1 padding-right-0px padding-left-6px">
                  <img class="img-circle-56" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
                </div>
                <div class="col-md-4 line-height-17px padding-left-0px padding-right-0px">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
                  <div><h4 class="margin-bottom-0px font-size-14 font-weight-bold color-Assign">OP ADV COLLECTION</h4></div>
                </div>
                <!--<div class="col-md-3" *ngIf="PatientDetails">

                </div>-->
                <div class="col-md-3 line-height-17px">
                </div>


                <div class="col-md-4">

                  <!--<button type="button" class="close float-right" data-dismiss="modal"
                          (click)="activeModal.dismiss('Cross click')"
                          aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>-->
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>

                  <button (click)="AddData('Opadv')" class="btn actions-btn-prime float-right font-size-15px ">Submit</button>
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px margin-right-5px" (click)="BackToCat('Opadv')">Back</button>
                </div>
              </div>
              <!--{{ sectionData.Title }}-->


            </div>

            <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
              <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
                  <!--<div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BillDate">{{BillDate| date:'MMM-dd-yyyy'}}</label></div>-->
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="date-form margin-top-5px form-group margin-bottom-0px">
                        <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>
                    </div>
                  </div>



                </div>
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
                  <div class="margin-top-5px"><h4 class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BranchName">{{BranchName}}</h4></div>
                </div>

                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Adv Amount</label></div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="margin-top-5px margin-bottom-3px">
                        <h4 class="margin-bottom-0px font-size-16px color-checkout font-weight-bold" *ngIf="AdvanceAmount">{{AdvanceAmount}}</h4>
                        <!--<input type="text" class="form-control" placeholder="AdvanceAmount"   required>

                                              <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && (AdvAm.dirty || AdvAm.touched) && AdvAm.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && AdvAm.errors.pattern)">(only numbers are allowed)</small>-->
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="card">


                    <div class="card-header wh-header border-bottom padding-bottom-0px">
                      <div class="row border-bottom">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px">Payment</label>
                        </div>

                      </div>
                    </div>
                    <div class="card-body padding-top-5px padding-bottom-0px padding-left-0px">
                      <div class="row">

                        <div class="col-md-12 padding-right-0px">
                          <div class="table-component margin-left-20p">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-103px padding-top-4px padding-bottom-4px"></th>
                                    <th class="min-width-157px padding-top-4px padding-bottom-4px">Amount</th>

                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Charges</th>
                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Ref.No</th>
                                    <th class="padding-top-4px padding-bottom-4px">Details</th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentPaymentDetails">
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="l.IsSelected" (change)="unchecked($event,l)">
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">{{l.PaymentMode}}</label>



                                    </td>
                                    <td>
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Amount" (input)="netpayablesum('add')"
                                             [(ngModel)]="l.Amount"
                                             name="l.Amount" pattern="^[\0-9,._\-?]*$"
                                             maxlength="10" *ngIf="l.IsSelected" #AmountCash="ngModel">

                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Charges"
                                             [(ngModel)]="l.Charges"
                                             name="l.Charges" pattern="^[\0-9,._\-?]*$" #ChargesCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Refno"
                                             [(ngModel)]="l.Refno"
                                             name="l.Refno" pattern="^[\0-9,._\-?]*$" #RefnoCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">


                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Details"
                                             [(ngModel)]="l.Details"
                                             name="l.Details" pattern="^[\0-9,._\-?]*$" #DetailsCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>



                                  </tr>

                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>

                      </div>
                    </div>






                  </div>
                </div>
              </div>

            </div>

          </div>
          <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12   document" *ngIf="Ipadvance">


            <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

              <div class="row" *ngIf="PatientDetails">
                <div class="col-md-1 padding-right-0px padding-left-6px">
                  <img class="img-circle-56" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
                </div>
                <div class="col-md-4 line-height-17px padding-left-0px padding-right-0px">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
                  <div><h4 class="margin-bottom-0px font-size-14 font-weight-bold color-Assign">IP ADV COLLECTION</h4></div>
                </div>
                <!--<div class="col-md-3" *ngIf="PatientDetails">

                </div>-->
                <div class="col-md-3 line-height-17px">
                  <label>Admission:</label>
                  <div class="row">
                    <div class="col-md-4"> <label class="margin-bottom-0px margin-top-7px"></label></div>
                    <div class="col-md-2 padding-left-0px margin-top-5px">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3 "> <i class="fas fa-ellipsis-h"></i></button>
                    </div>

                  </div>
                </div>


                <div class="col-md-4">

                  <!--<button type="button" class="close float-right" data-dismiss="modal"
                          (click)="activeModal.dismiss('Cross click')"
                          aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>-->
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>

                  <button (click)="AddData('Ipadv')" class="btn actions-btn-prime float-right font-size-15px ">Submit</button>
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px margin-right-5px" (click)="BackToCat('Opadv')">Back</button>
                </div>
              </div>
              <!--{{ sectionData.Title }}-->


            </div>

            <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
              <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
                  <!--<div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BillDate">{{BillDate| date:'MMM-dd-yyyy'}}</label></div>-->
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="date-form margin-top-5px form-group margin-bottom-0px">
                        <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>
                    </div>
                  </div>



                </div>
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
                  <div class="margin-top-5px"><h4 class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BranchName">{{BranchName}}</h4></div>
                </div>

                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Adv Amount</label></div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="margin-top-5px margin-bottom-3px">
                        <input type="text" class="form-control" placeholder="Advance Amount"
                               [(ngModel)]="AdvanceAmount"
                               name="Amount" #AdvAm="ngModel"
                               maxlength="10" pattern="^[\0-9,._\-?]*$" required>
                        <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && (AdvAm.dirty || AdvAm.touched) && AdvAm.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && AdvAm.errors.pattern)">(only numbers are allowed)</small>

                        <!--<input type="text" class="form-control" placeholder="AdvanceAmount"   required>

                                              <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && (AdvAm.dirty || AdvAm.touched) && AdvAm.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && AdvAm.errors.pattern)">(only numbers are allowed)</small>-->
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="card">


                    <div class="card-header wh-header border-bottom padding-bottom-0px">
                      <div class="row border-bottom">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px">Payment</label>
                        </div>

                      </div>
                    </div>
                    <div class="card-body padding-top-5px padding-bottom-0px padding-left-0px">
                      <div class="row">

                        <div class="col-md-12 padding-right-0px">
                          <div class="table-component margin-left-20p">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-103px padding-top-4px padding-bottom-4px"></th>
                                    <th class="min-width-157px padding-top-4px padding-bottom-4px">Amount</th>

                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Charges</th>
                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Ref.No</th>
                                    <th class="padding-top-4px padding-bottom-4px">Details</th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentPaymentDetails">
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="l.IsSelected">
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">{{l.PaymentMode}}</label>



                                    </td>
                                    <td>
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Amount"
                                             [(ngModel)]="l.Amount"
                                             name="l.Amount" pattern="^[\0-9,._\-?]*$"
                                             maxlength="10" *ngIf="l.IsSelected" #AmountCash="ngModel">

                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Charges"
                                             [(ngModel)]="l.Charges"
                                             name="l.Charges" pattern="^[\0-9,._\-?]*$" #ChargesCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Refno"
                                             [(ngModel)]="l.Refno"
                                             name="l.Refno" pattern="^[\0-9,._\-?]*$" #RefnoCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">


                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Details"
                                             [(ngModel)]="l.Details"
                                             name="l.Details" pattern="^[\0-9,._\-?]*$" #DetailsCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>



                                  </tr>

                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>

                      </div>
                    </div>






                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="modal-signup modal-content" *ngIf="Type=='FromProfile'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-body padding-top-0px margin-left-0px padding-right-0px padding-left-0px padding-bottom-0px">

        <div class="modal-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Categories">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Individual">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->


          <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12   document">


            <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

              <div class="row" *ngIf="PatientDetails">
                <div class="col-md-1 padding-right-0px padding-left-6px">
                  <img class="img-circle-56" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
                </div>
                <div class="col-md-4 line-height-17px padding-left-0px padding-right-0px">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
                  <div><h4 class="margin-bottom-0px font-size-14 font-weight-bold color-Assign">OP ADV COLLECTION</h4></div>
                </div>
                <!--<div class="col-md-3" *ngIf="PatientDetails">

                </div>-->
                <div class="col-md-3 line-height-17px">
                </div>


                <div class="col-md-4">

                  <!--<button type="button" class="close float-right" data-dismiss="modal"
                          (click)="activeModal.dismiss('Cross click')"
                          aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>-->
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>

                  <button (click)="AddData('Opadv')" class="btn actions-btn-prime float-right font-size-15px ">Submit</button>
                  <!--<button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px margin-right-5px" (click)="BackToCat('Opadv')">Back</button>-->
                </div>
              </div>
              <!--{{ sectionData.Title }}-->


            </div>

            <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
              <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
                  <!--<div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BillDate">{{BillDate| date:'MMM-dd-yyyy'}}</label></div>-->
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="date-form margin-top-5px form-group margin-bottom-0px">
                        <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>
                    </div>
                  </div>



                </div>
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
                  <div class="margin-top-5px"><h4 class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BranchName">{{BranchName}}</h4></div>
                </div>

                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Adv Amount</label></div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="margin-top-5px margin-bottom-3px">
                        <h4 class="margin-bottom-0px font-size-16px color-checkout font-weight-bold" *ngIf="AdvanceAmount">{{AdvanceAmount}}</h4>
                        <!--<input type="text" class="form-control" placeholder="AdvanceAmount"   required>

                                              <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && (AdvAm.dirty || AdvAm.touched) && AdvAm.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && AdvAm.errors.pattern)">(only numbers are allowed)</small>-->
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="card">


                    <div class="card-header wh-header border-bottom padding-bottom-0px">
                      <div class="row border-bottom">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px">Payment</label>
                        </div>

                      </div>
                    </div>
                    <div class="card-body padding-top-5px padding-bottom-0px padding-left-0px">
                      <div class="row">

                        <div class="col-md-12 padding-right-0px">
                          <div class="table-component margin-left-20p">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-103px padding-top-4px padding-bottom-4px"></th>
                                    <th class="min-width-157px padding-top-4px padding-bottom-4px">Amount</th>

                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Charges</th>
                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Ref.No</th>
                                    <th class="padding-top-4px padding-bottom-4px">Details</th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentPaymentDetails">
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="l.IsSelected" (change)="unchecked($event,l)">
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">{{l.PaymentMode}}</label>



                                    </td>
                                    <td>
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Amount" (input)="netpayablesum('add')"
                                             [(ngModel)]="l.Amount"
                                             name="l.Amount" pattern="^[\0-9,._\-?]*$"
                                             maxlength="10" *ngIf="l.IsSelected" #AmountCash="ngModel">

                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Charges"
                                             [(ngModel)]="l.Charges"
                                             name="l.Charges" pattern="^[\0-9,._\-?]*$" #ChargesCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Refno"
                                             [(ngModel)]="l.Refno"
                                             name="l.Refno" pattern="^[\0-9,._\-?]*$" #RefnoCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">


                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Details"
                                             [(ngModel)]="l.Details"
                                             name="l.Details" pattern="^[\0-9,._\-?]*$" #DetailsCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>



                                  </tr>

                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>

                      </div>
                    </div>






                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="Type=='IpAdvance'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-body padding-top-0px margin-left-0px padding-right-0px padding-left-0px padding-bottom-0px">

        <div class="modal-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Categories">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Individual">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->


          <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12   document">


            <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

              <div class="row" *ngIf="PatientDetails">
                <div class="col-md-1 padding-right-0px padding-left-6px">
                  <img class="img-circle-56" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
                </div>
                <div class="col-md-4 line-height-17px padding-left-0px padding-right-0px">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
                  <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
                  <div><h4 class="margin-bottom-0px font-size-14 font-weight-bold color-Assign">IP ADV COLLECTION</h4></div>
                </div>
                <!--<div class="col-md-3" *ngIf="PatientDetails">

                </div>-->
                <div class="col-md-3 line-height-17px">
                </div>


                <div class="col-md-4">

                  <!--<button type="button" class="close float-right" data-dismiss="modal"
                          (click)="activeModal.dismiss('Cross click')"
                          aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>-->
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>

                  <button (click)="AddData2()" class="btn actions-btn-prime float-right font-size-15px ">Submit</button>
                  <!--<button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px margin-right-5px" (click)="BackToCat('Opadv')">Back</button>-->
                </div>
              </div>
              <!--{{ sectionData.Title }}-->


            </div>

            <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
              <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
                  <!--<div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BillDate">{{BillDate| date:'MMM-dd-yyyy'}}</label></div>-->
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="date-form margin-top-5px form-group margin-bottom-0px">
                        <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>
                    </div>
                  </div>



                </div>
                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
                  <div class="margin-top-5px"><h4 class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BranchName">{{BranchName}}</h4></div>
                </div>

                <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                  <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Adv Amount</label></div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-7 margin-left-auto margin-right-auto">
                      <div class="margin-top-5px margin-bottom-3px">
                        <h4 class="margin-bottom-0px font-size-16px color-checkout font-weight-bold" *ngIf="AdvanceAmount">{{AdvanceAmount}}</h4>
                        <!--<input type="text" class="form-control" placeholder="AdvanceAmount"   required>

                                              <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && (AdvAm.dirty || AdvAm.touched) && AdvAm.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!AdvAm.valid && AdvAm.errors.pattern)">(only numbers are allowed)</small>-->
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="card">


                    <div class="card-header wh-header border-bottom padding-bottom-0px">
                      <div class="row border-bottom">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px">Payment</label>
                        </div>

                      </div>
                    </div>
                    <div class="card-body padding-top-5px padding-bottom-0px padding-left-0px">
                      <div class="row">

                        <div class="col-md-12 padding-right-0px">
                          <div class="table-component margin-left-20p">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-103px padding-top-4px padding-bottom-4px"></th>
                                    <th class="min-width-157px padding-top-4px padding-bottom-4px">Amount</th>

                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Charges</th>
                                    <th class="th-width-170px padding-top-4px padding-bottom-4px">Ref.No</th>
                                    <th class="padding-top-4px padding-bottom-4px">Details</th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentPaymentDetails">
                                    <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="l.IsSelected" (change)="unchecked($event,l)">
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">{{l.PaymentMode}}</label>



                                    </td>
                                    <td>
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Amount" (input)="netpayablesum('add')"
                                             [(ngModel)]="l.Amount"
                                             name="l.Amount" pattern="^[\0-9,._\-?]*$"
                                             maxlength="10" *ngIf="l.IsSelected" #AmountCash="ngModel">

                                    </td>
                                    <td class="text-align-right">
                                      <input type="text" class="form-control text-align-right"
                                             min="1" max="10" id="l.Charges"
                                             [(ngModel)]="l.Charges"
                                             name="l.Charges" pattern="^[\0-9,._\-?]*$" #ChargesCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>

                                    <td class="td-padding ">

                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Refno"
                                             [(ngModel)]="l.Refno"
                                             name="l.Refno" pattern="^[\0-9,._\-?]*$" #RefnoCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">


                                    </td>

                                    <td>
                                      <input type="text" class="form-control"
                                             min="1" max="10" id="l.Details"
                                             [(ngModel)]="l.Details"
                                             name="l.Details" pattern="^[\0-9,._\-?]*$" #DetailsCash="ngModel"
                                             maxlength="10" *ngIf="l.IsSelected">

                                    </td>



                                  </tr>

                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>

                      </div>
                    </div>






                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>
